import { Accessibility } from "../../models/Accessibility";
import { a } from "../utils";



export const fetchA11yes = (payload: Accessibility[]) => a({ type: "FETCH_A11YES", payload });
export const clearA11yes = () => a({ type: "CLEAR_A11YES", payload: [] as any[] });
export const createA11y = (payload: Accessibility) => a({ type: "CREATE_A11Y", payload });
export const deleteA11y = (payload: number) => a({ type: "DELETE_A11Y", payload });
export const fetchA11yesByProperty = (payload: Accessibility[]) => a({ type: "FETCH_A11YES_BY_PROPERTY", payload });
export const clearA11yesByProperty = () => a({ type: "CLEAR_A11YES_BY_PROPERTY" });

export const fetchCountDisabilityTypes = (
  payload: Array<{name: string, value: number}>
) => a({ type: "FETCH_COUNTS_DISABILITY_TYPES", payload });

export const clearCountDisabilityTypes = () => a(
  { type: "CLEAR_COUNTS_DISABILITY_TYPES" }
);

export const updateA11y = (payload: {
    response: Accessibility, index: number
}) => a({ type: "UPDATE_A11Y", payload });

export const partialUpdateA11y = (payload: {
    response: Accessibility, index: number
}) => a({ type: "UPDATE_A11Y", payload });